import { createElement } from 'react';
import { Checkbox as OriginalCheckbox } from 'antd';
const Checkbox = function Checkbox({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalCheckbox, { ..._otherProps }, _otherProps.children));
};
export default Checkbox;
